import { shareColumnsExtend, shareFormColumnsExtend } from './share';
export const DELIVERY_FOLLOW_UP_RECORD_FOLLOW_UP_TYPES = [
  'near_3_day_shipment',
  'overdue',
]

export const DELIVERY_FOLLOW_UP_RECORD_RESULTS = [
  'contacted',
  'urged',
  'not_shipped',
  'waiting_factory_reply',
  'rescheduled',
  'shipped',
  'completed',
]

const entityColumns = {
  id: {
    model_name: 'DeliveryFollowUpRecord',
    column_type: 'id',
    label_key_path: 'deliveryFollowUpRecord.id',
  },
  created_at: {
    model_name: 'DeliveryFollowUpRecord',
    column_type: 'datetime',
    label_key_path: 'deliveryFollowUpRecord.createdAt',
  },
  updated_at: {
    model_name: 'DeliveryFollowUpRecord',
    column_type: 'datetime',
    label_key_path: 'deliveryFollowUpRecord.updatedAt',
  },
  order: {
    model_name: 'DeliveryFollowUpRecord',
    column_type: 'belongs_to',
    label_key_path: 'deliveryFollowUpRecord.order',
    extra: {
      association_name: 'order',
      model_name: 'Order',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  order_id: {
    model_name: 'DeliveryFollowUpRecord',
    column_type: 'belongs_to',
    label_key_path: 'deliveryFollowUpRecord.order',
    extra: {
      association_name: 'order',
      model_name: 'Order',
      foreign_key: 'order_id',
      display_column: 'id',
    },
  },
  follow_up_type: {
    model_name: 'DeliveryFollowUpRecord',
    column_type: 'enum',
    extra: {
      options: ['near_3_day_shipment', 'overdue'],
    },
    label_key_path: 'deliveryFollowUpRecord.followUpType',
  },
  result: {
    model_name: 'DeliveryFollowUpRecord',
    column_type: 'enum',
    extra: {
      options: ['contacted', 'urged', 'not_shipped', 'waiting_factory_reply', 'rescheduled', 'shipped', 'completed'],
    },
    label_key_path: 'deliveryFollowUpRecord.result',
  },
  note: {
    model_name: 'DeliveryFollowUpRecord',
    column_type: 'text',
    label_key_path: 'deliveryFollowUpRecord.note',
  },
  operator: {
    model_name: 'DeliveryFollowUpRecord',
    column_type: 'belongs_to',
    label_key_path: 'deliveryFollowUpRecord.operator',
    extra: {
      association_name: 'operator',
      model_name: 'User',
      foreign_key: 'operator_id',
      display_column: 'screen_name',
    },
  },
  operator_id: {
    model_name: 'DeliveryFollowUpRecord',
    column_type: 'belongs_to',
    label_key_path: 'deliveryFollowUpRecord.operator',
    extra: {
      association_name: 'operator',
      model_name: 'User',
      foreign_key: 'operator_id',
      display_column: 'screen_name',
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
